import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import CarouselMax from './carrouselMax'
import Container from './container'

export default function Depoimentos() {
  const isSmallScreen = window.innerWidth < 640
  const scrollRef = useRef(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  const cardsInfo = [
    { autor: 'Cristiano Silveira' },
    { autor: 'Odilon Devens' },
    { autor: 'Angela Gonçalves' },
    { autor: 'Luiz Gustavo Furlan' },
    { autor: 'Vania Pankievicz' },
    { autor: 'Carla Barcelos' },
  ]

  const scroll = direction => {
    if (direction === 'left') {
      scrollRef.current.scrollBy({ left: -292, behavior: 'smooth' })
      setCurrentIndex(prev => Math.max(0, prev - 1)) // Update index when scrolling left
    } else {
      scrollRef.current.scrollBy({ left: 292, behavior: 'smooth' })
      setCurrentIndex(prev => Math.min(prev + 1, cardsInfo.length - 1)) // Update index when scrolling right
    }
  }

  // Handle manual scrolling by detecting scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        const scrollPosition = scrollRef.current.scrollLeft
        const cardWidth = 292 // Width of each card including gap
        const newIndex = Math.round(scrollPosition / cardWidth)

        // Only update if the index has actually changed
        if (
          newIndex !== currentIndex &&
          newIndex >= 0 &&
          newIndex < cardsInfo.length
        ) {
          setCurrentIndex(newIndex)
        }
      }
    }

    const scrollElement = scrollRef.current
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll)
      return () => scrollElement.removeEventListener('scroll', handleScroll)
    }
  }, [currentIndex, cardsInfo.length])

  return !isSmallScreen ? (
    <div id="depoimentos" className="w-full bg-[#040116] p-[70px]">
      <div className="max-w-[1400px] my-auto mx-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="font-raleway text-white text-5xl text-left">
              O que nossos clientes
            </h1>
            <h1 className="font-raleway_bold text-white text-5xl text-left my-4">
              dizem sobre nós
            </h1>
          </div>
          <img
            src="/assets/simbolo_projectiva_1.svg"
            alt="Símbolo Projectiva"
            className="mr-4"
          />
        </div>
        <div className="w-full -mt-8 relative">
          <CarouselMax isMobile={false} />
          <div className="absolute bottom-[10px] w-[326px]">
            <img
              src="/assets/arrow_gradient.svg"
              alt="Next"
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Container
      id="depoimentos"
      className="w-full bg-[#040116] pt-16 pb-[71px] space-y-10 overflow-hidden"
    >
      <div className="relative w-full flex flex-row items-center justify-between">
        <div className="flex-1">
          <div className="text-center">
            <h1 className="font-raleway text-white text-2xl">
              O que nossos clientes
              <br />
              <strong className="font-raleway_bold">dizem sobre nós</strong>
            </h1>
          </div>
        </div>
      </div>
      <div ref={scrollRef} className="flex overflow-x-scroll scrollbar-hide">
        <div className="flex flex-row">
          <CarouselMax isMobile={true} currentIndex={currentIndex} />
        </div>
      </div>
      <div className="flex flex-row justify-between items-center max-w-64 mx-auto text-white">
        <ChevronLeft size={30} onClick={() => scroll('left')} />

        {/* Carousel dots - one for each card */}
        <div className="flex space-x-2 overflow-x-auto">
          {cardsInfo.map((_, i) => (
            <div
              key={i}
              onClick={() => {
                setCurrentIndex(i)
                scrollRef.current.scrollTo({
                  left: i * 292,
                  behavior: 'smooth',
                })
              }}
              className={`h-[8px] rounded-full cursor-pointer transition-all duration-300 ${
                i === currentIndex
                  ? 'w-[24px] bg-transparent border border-white'
                  : 'w-[8px] bg-white'
              }`}
            />
          ))}
        </div>

        <ChevronRight size={30} onClick={() => scroll('right')} />
      </div>
      <img
        src="/assets/arrow_gradient.svg"
        alt="Next"
        className="block absolute left-0 w-fit"
      />
    </Container>
  )
}
